const checkInFlowCopy = {
  en: {
    home: {
      welcomeTo: "Welcome to",
      emailPhoneInstruction:
        "Please enter your email or phone number to start the check-in process",
      emailPhonePlaceholder: "email or phone number",
      qrInstruction: "Or do it yourself on your device.",
    },
    formCheck: {
      welcomeTo: "Welcome to",
      emailPhoneInstruction:
        "Please enter your email or phone number to begin filling out your form",
      emailPhonePlaceholder: "email or phone number",
    },
    requestOtp: {
      welcomeTo: "Welcome to",
      otpIntro:
        "To continue with the checkin form process we will send you a secret code to your email or phone",
      whereReceiveCode: "Where would you like to recieve the code",
      getOnPhone: "Get it on your phone",
      getOnEmail: "Get it on your email",
    },
    verifyOtp: {
      welcomeTo: "Welcome to",
      enterCode: "Please enter the code that we sent you",
      secretCodePlaceholder: "Enter your secret code",
    },
  },
  es: {
    home: {
      welcomeTo: "Bienvenido a",
      emailPhoneInstruction:
        "Por favor ingresa tu correo electrónico o número de teléfono para iniciar el proceso de check-in",
      emailPhonePlaceholder: "correo o teléfono",
      qrInstruction: "O hazlo tú mismo en tu dispositivo.",
    },
    formCheck: {
      welcomeTo: "Bienvenido a",
      emailPhoneInstruction:
        "Por favor ingresa tu correo electrónico o número de teléfono para iniciar el proceso de check-in",
      emailPhonePlaceholder: "correo o teléfono",
    },
    requestOtp: {
      welcomeTo: "Bienvenido a",
      otpIntro:
        "Para continuar con el proceso de llenado del formulario, te enviaremos un código secreto a tu correo o teléfono",
      whereReceiveCode: "Donde te gustaría recibir el código",
      getOnPhone: "Obténlo en tu teléfono",
      getOnEmail: "Obténlo en tu correo electrónico",
    },
    verifyOtp: {
      welcomeTo: "Bienvenido a",
      enterCode: "Por favor ingresa el código que te enviamos",
      secretCodePlaceholder: "Ingresa el código secreto",
    },
  },
};

/** Claves por pantalla (para toggles por componente). */
export const CHECK_IN_COPY_SCREENS = [
  "home",
  "formCheck",
  "requestOtp",
  "verifyOtp",
];

export const CHECK_IN_SCREEN = {
  HOME: "home",
  FORM_CHECK: "formCheck",
  REQUEST_OTP: "requestOtp",
  VERIFY_OTP: "verifyOtp",
};

/** @param {keyof typeof CHECK_IN_SCREEN | string} screen @param {"en"|"es"} lang */
export function getCheckInScreenCopy(screen, lang) {
  return checkInFlowCopy[lang][screen];
}

export default checkInFlowCopy;
